import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToNotify = () => {
    const element = document.getElementById('notify-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-170">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-171">
        <span className="font-bold text-2xl md:text-3xl tracking-wide uppercase bg-gradient-to-r from-brand-black to-brand-teal bg-clip-text text-transparent" style={{
        fontFamily: "'Oswald', sans-serif"
      }} data-id="element-172">
          Inclusive Succession
        </span>
        <button onClick={scrollToNotify} className="bg-brand-black text-white px-6 py-2.5 rounded-full font-medium text-sm hover:bg-brand-teal transition-colors duration-300" data-id="element-173">
          Get Notified
        </button>
      </div>
    </motion.nav>;
}